import type { CheckboxProps } from "@octopusdeploy/design-system-components";
import { Checkbox } from "@octopusdeploy/design-system-components";
import { withBoundField } from "./BoundField";
export const BoundCheckbox = withBoundField<boolean, CheckboxProps>(Checkbox);
